export default "__VITE_ASSET__Nrv3gQE3__"